<template>
  <div id="Dashboard"  class="container is-fluid" >
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="Test Parts DB" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        <div>
          <label for="part_selected">part_selected</label>
          <input type="text" v-model="part_selected" id="part_selected" name="part_selected">
        </div>
        
        <textarea id='parts_text' class='textarea' rows=10
              placeholder="Part Number(s)" style="display:inline-block; max-width:auto; min-width:auto"
              v-model="parts_text" @input="parts_text=$event.target.value.toUpperCase()"/>

        <div class="buttons is-right">
          <button @click='reset' class="button is-small is-white">Reset</button>
          <button @click='ajax_get_dashboard' class="button is-info">Filter</button>
        </div>
      </div>
    </section>

    <section id="partsdb_parts" v-if="dbPartData.length>0">
      <div class="title_div">
        <span class="site">Parts (Various Sources)</span>
      </div>
      <vue-good-table  
        :name="'table_parts_db'"
        :select-options="{ 
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'parts selected',
        }"
        :pagination-options="{
          enabled: is_paged_db_part
        }"
        :rows="dbPartData"
        :columns="shared_db_part_columns"
      >
        <template v-slot:table-row="props">
          <span v-if="props.column.field == 'source'">
            <a :href=props.row.url target="_blank">{{props.formattedRow[props.column.field]}}</a>
          </span>
          <span v-else-if="props.column.field == 'description'">
            <span v-if="props.formattedRow[props.column.field].length > 150" :title=props.formattedRow[props.column.field]>
              {{props.formattedRow[props.column.field].substring(0,150)}} ...
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </span>
          <div v-else-if="props.column.field == 'common_attributes'">
            <div v-if="props.row[props.column.field] == null">
              {{props.formattedRow[props.column.field]}}
            </div>
            <div v-else-if=" Object.keys(props.row[props.column.field]).length > 2" :title="get_attr_title(props.row[props.column.field])">
              <div v-for="(value, key, idx) in props.row[props.column.field]" :key="key">
                <div v-if="idx < 2">
                  {{ key }} : {{ value }}
                </div>
              </div> 
              ...
            </div>
            <div v-else>
              <div v-for="(value, key) in props.row[props.column.field]" :key="key">
                {{ key }} : {{ value }}
              </div>
            </div>
          </div>
          <div v-else-if="props.column.field == 'bulk_prices'">
            <div v-if="props.row[props.column.field] == null">
              {{props.formattedRow[props.column.field]}}
            </div>
            <div v-else-if=" Object.keys(props.row[props.column.field]).length > 2" :title="get_attr_title(props.row[props.column.field])">
              <div v-for="(value, key, idx) in props.row[props.column.field]" :key="key">
                <div v-if="idx < 2">
                  {{ key }} : {{ value }}
                </div>
              </div> 
              ...
            </div>
            <div v-else>
              <div v-for="(value, key) in props.row[props.column.field]" :key="key">
                {{ key }} : {{ value }}
              </div>
            </div>
          </div>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [dbPartDataRaw, 'PartResults', null])">
          Download CSV
        </button>
      </div>
    </section>


    <section id="partsdb_subs" v-if="dbPartDataSub.length>0">
      <div class="title_div">
        <span class="site">Substitutes (Various Sources)</span>
      </div>
      <vue-good-table  
        :name="'table_parts_db_subs'"
        :select-options="{ 
          enabled: true,
          selectOnCheckboxOnly: true,
          selectionText: 'parts selected',
        }"
        :pagination-options="{
          enabled: is_paged_db_sub
        }"
        :rows="dbPartDataSub"
        :columns="shared_db_part_columns"
      >
        <template v-slot:table-row="props">
          <span v-if="props.column.field == 'source'">
            <a :href=props.row.url target="_blank">{{props.formattedRow[props.column.field]}}</a>
          </span>
          <span v-else-if="props.column.field == 'description'">
            <span v-if="props.formattedRow[props.column.field].length > 150" :title=props.formattedRow[props.column.field]>
              {{props.formattedRow[props.column.field].substring(0,150)}} ...
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </span>
          <div v-else-if="props.column.field == 'common_attributes'">
            <div v-if="props.row[props.column.field] == null">
              {{props.formattedRow[props.column.field]}}
            </div>
            <div v-else-if=" Object.keys(props.row[props.column.field]).length > 2" :title="get_attr_title(props.row[props.column.field])">
              <div v-for="(value, key, idx) in props.row[props.column.field]" :key="key">
                <div v-if="idx < 2">
                  {{ key }} : {{ value }}
                </div>
              </div> 
              ...
            </div>
            <div v-else>
              <div v-for="(value, key) in props.row[props.column.field]" :key="key">
                {{ key }} : {{ value }}
              </div>
            </div>
          </div>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [dbPartDataRaw, 'SubResults', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>

<style scoped>
  .title_div{
    margin-top: 1.5em;
  }

  .site{
    font-size: 2em;
  }

</style>

<script>
import { VueGoodTable } from 'vue-good-table-next';
import moment from 'moment';
import HeroContainer from '@/components/shared/HeroContainer.vue';
import { 
  TEST_PARTS_DB
 } from '@/data/url';
import { mapStores } from 'pinia'
import { useDropdownsStore } from '@/stores/dropdownsStore'

export default {
  name: 'TestPartsDB',
  components: {
    VueGoodTable,
    HeroContainer,
  },
  data: function(){
    return {
      numeral: require('numeral'),
      parts_text: '',
      dbPartDataRaw: [],
      part_selected: '',
    };
  },
  computed:{
    ...mapStores(useDropdownsStore),
    shared_db_part_columns(){
      let numeral = this.numeral
      return [
        {
          label: 'Source',
          field: 'source',
          type: 'text',
        },
        {
          label: 'Part Number',
          field: 'part_number',
          type: 'text',
        },
        {
          label: 'Mfr Number',
          field: 'mfr_no',
          type: 'text',
        },
        {
          label: 'Description',
          field: 'description',
          type: 'text',
        },
        {
          label: 'Price',
          field: 'price',
          type: 'number',
          formatFn: (value) => {
            if(value){
              return numeral(value).format('$0,0,0,0,0.00')
            }
            return value
          }
        },
        {
          label: 'UOM',
          field: 'uom',
          type: 'text',
        },
        {
          label: 'Qty',
          field: 'qty',
          type: 'number',
        },
        {
          label: 'In Stock',
          field: 'in_stock',
          type: 'text',
        },
        {
          label: 'Bulk',
          field: 'bulk_prices',
          type: 'text',
        },
        {
          label: 'Min Qty',
          field: 'min_qty',
          type: 'number',
        },
        {
          label: 'Lead',
          field: 'lead_time',
          type: 'text',
        },
        {
          label: 'Attr',
          field: 'common_attributes',
          type: 'text',
        },
        {
          label: 'Updated',
          field: 'time_updated',
          type: 'text',
          formatFn: (date) => {
            if(date){
              if(date.includes('T')){
                return date.split('T')[0]
              }
            }
            return date
          }
        },

      ]
    },
    is_paged_db_part: function(){
      if(this.dbPartData.length <= 10){
        return false
      }else{
        return true
      }
    },
    is_paged_db_sub: function(){
      if(this.dbPartDataSub.length <= 10){
        return false
      }else{
        return true
      }
    },
    customer_items(){
      // For customer dropdown
      return this.dropdownsStore.customer
    },
    vendor_items(){
      // For vendor dropdown
      return this.dropdownsStore.vendor
    },
    user_items(){
      // For vendor dropdown
      return this.dropdownsStore.user
    },
    dbPartData(){
      let part_data = []
      let raw_data = [...this.dbPartDataRaw]  // Copy to new array
      let part_selected = this.part_selected
      for(let raw_idx in raw_data){
        let raw_row = raw_data[raw_idx]
        let part_number = raw_row.part_number
        if(part_number == part_selected){
          part_data.push(raw_row)
        }
      }
      return part_data
    },
    dbPartDataSub(){
      let sub_data = []
      let raw_data = [...this.dbPartDataRaw]
      for(let raw_idx in raw_data){
        let part_selected = this.part_selected
        let raw_row = raw_data[raw_idx]
        let sub_for = raw_row.substitute_for
        if(sub_for){
          if(sub_for.includes(part_selected)){
            sub_data.push(raw_row)
          }
        }
      }
      return sub_data
    },    
  },
  methods: {
    get_attr_title(attributes){
      let attr_text = '';
      for (const key in attributes){
        attr_text += `${key}: ${attributes[key]}\n`
      }
      return attr_text
    },
    reset(){
      this.dbPartDataRaw = []
      this.customer = ''
      this.vendor = ''
      this.user = ''
      this.date_range=  'this_quarter'
      this.range = [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ]
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      this.dbPartDataRaw = []
      let url = TEST_PARTS_DB
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, data){
        this_vue.dbPartDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({part_list: this.parts_text, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
